export default __webpack_public_path__ + "static/media/victoria harbor hong kong.019dcfbb.jpg";